/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersresend2Inputs */

const en_dropwinnersresend2 = /** @type {(inputs: Dropwinnersresend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send again`)
};

const de_dropwinnersresend2 = /** @type {(inputs: Dropwinnersresend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut senden`)
};

/**
* | output |
* | --- |
* | "Send again" |
*
* @param {Dropwinnersresend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersresend2 = /** @type {((inputs?: Dropwinnersresend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersresend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersresend2(inputs)
	return de_dropwinnersresend2(inputs)
});
export { dropwinnersresend2 as "dropWinnersResend" }